
import { defineComponent, onMounted, ref, computed } from 'vue';
import { routerInitialPath } from 'PortalDir/router/router.constants';
import ServiceList from 'PortalDir/modules/Main/components/Service/List.vue';
import NewsList from 'PortalDir/modules/Main/components/News/List.vue';
import UserList from 'PortalDir/modules/Main/components/Statistics/User/List.vue';
import IssueDepList from 'PortalDir/modules/Main/components/Statistics/IssueDep/List.vue';
import useValidation from 'SharedDir/common/composables/useValidation';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { useAppStore } from 'stores/app';
import { preFetch } from 'quasar/wrappers';
import { usePublicServicesList } from 'PortalDir/modules/Services/composables/usePublicServicesList';
import { usePublicNewsList } from 'PortalDir/modules/News/composables/usePublicNewsList';
import { usePublicStatistics } from 'PortalDir/modules/Main/components/Statistics/composables/usePublicStatistics';
import IssueList from 'PortalDir/modules/Main/components/Statistics/Issue/List.vue';
import { useRouter } from 'vue-router';
import { useLoadingSsr } from 'PortalDir/common/composables/useLoadingSsr';
import { useI18n } from 'vue-i18n';
import { REGION_ENVIRONMENT } from 'PortalDir/constants/app/common';
import { FeatureFlagName } from 'SharedDir/declarations/system/region-customization';
import { useFeatureFlags } from 'SharedDir/common/composables/useFeatureFlags';
import { useMeta, useHydration } from 'quasar';
import { useAISearchChat } from 'PortalDir/common/composables/useAISearchChat';
import { useMetaPortal } from 'SharedDir/common/composables/useMetaPortal';

import { SEARCH_MODE_TYPES, SearchModeType } from '../constants/main.constants';

async function getData(appStore) {
  await appStore.setMainSsrLoad(true);

  const { getShortServiceList } = usePublicServicesList();
  const service = await getShortServiceList();
  await appStore.setServiceList(service);

  const { getShortNewsList } = usePublicNewsList();
  const news = await getShortNewsList();
  await appStore.setNewsList(news);
}

export default defineComponent({
  name: 'IndexPage',
  components: { IssueList, IssueDepList, UserList, NewsList, ServiceList },
  props: {
    openLoginModal: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  // РАБОТАЕТ ТОЛЬКО НА СТРАНИЦАХ ИЗ ROUTES!!!
  // LESHA SSR RABOTAET!!! НО У ТЕБЯ ВЫПОЛНЯЕТСЯ ЗАПРОС НА СЕРВЕРЕ И ПОТОМ НА ФРОНТЕ, НЕ НАДО ТАК!!!
  // СДЕЛАЙ КРАСИВО ЕЩЁ СМЕНУ ПРОФИЛЯ!!!
  preFetch: preFetch(async ({ store, ssrContext }) => {
    const appStore = useAppStore(store);
    await getData(appStore);
  }),

  setup(props) {
    const { isLoading } = useLoadingSsr();
    const router = useRouter();
    const { NotEmpty } = useValidation();
    const { isMobile } = useDeviceSize();
    const { t } = useI18n();
    const { getFeatureFlag } = useFeatureFlags();
    const { isHydrated } = useHydration();
    const { openAISearch, isVisibleAISearch } = useAISearchChat();

    const activeSearchTypes = ref(
      isVisibleAISearch
        ? SearchModeType.ai
        : SearchModeType.regular
    );
    const aiIsActiveSearchType = computed(
      () => activeSearchTypes.value === SearchModeType.ai
    );

    const serviceSearch = ref(null);

    function servicePath() {
      return { name: 'services', query: { name: serviceSearch.value } };
    }

    function goToService() {
      if (aiIsActiveSearchType.value) {
        openAISearch(serviceSearch.value);
        return;
      }

      router.push(servicePath());
    }
    const appStore = useAppStore();

    onMounted(async () => {
      try {
        const { getIssuesDepList } = usePublicStatistics();
        const issuesDep = await getIssuesDepList();
        await appStore.setIssueDepPublicList(issuesDep);

        const { getIssuesList } = usePublicStatistics();
        const issues = await getIssuesList({
          groupBy: null,
          isCompleted: null,
        });
        await appStore.setIssuePublicList(issues);

        const { getUserList } = usePublicStatistics();
        const user = await getUserList();
        await appStore.setUserPublicList(user);
      } finally {
        console.log(props.openLoginModal, 'MODAL LOGIN');
        if (props.openLoginModal) {
          appStore.showAuthDialog();
        }
        isLoading.value = false;
      }
    });

    const { clearFullPageUrl } = useMetaPortal();

    useMeta(() => {
      return {
        title: `Портал - ${t('systemType')} ${t('systemShortName')}`,
        meta: {
          description: {
            name: 'description',
            template: () => `${t('systemDescription')}`,
          },
          keywords: {
            name: 'keywords',
            template: () =>
              [
                `${t('systemType')} ${t('systemShortName')}`,
                `${t('systemType')} ${t('systemShortName')}`,
                ` Портал ${t('systemShortName')}`,
                `${t('systemShortName')} ${t('regionFullName')}`,
                `${t('systemShortName')} ${t('regionShortName')}`,
                `Новости ${t('systemShortName')}`,
                `Новости ${t('regionShortName')}`,
                `Новости ${t('regionFullName')}`,
                `Меры поддержки ${t('systemShortName')}`,
                `Меры поддержки ${t('regionFullName')}`,
                `Меры поддержки ${t('regionShortName')}`,
                `${t('regionShortName')} ${t('systemShortName')}`,
                `${t('regionFullName')} ${t('systemShortName')}`,
              ].join(', '),
          },
        },
        link: {
          canonical: {
            rel: 'canonical',
            href: clearFullPageUrl.value,
          },
        },
      };
    });

    return {
      routerInitialPath,
      activeSearchTypes,
      SEARCH_MODE_TYPES,
      NotEmpty,
      serviceSearch,
      isMobile,
      goToService,
      servicePath,
      isLoading,
      t,
      REGION_ENVIRONMENT,
      isVisibleStatistics: getFeatureFlag(FeatureFlagName.IsVisibleStatisticsInPortal),
      isVisibleAISearch,
      isHydrated,
    };
  },
});
